import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import NoSsr from '@material-ui/core/NoSsr';
import Select from 'react-select';

import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import { emphasize } from '@material-ui/core/styles/colorManipulator';
import { asField } from 'informed';
import { get } from 'lodash-es';

import {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
} from './ReactSelectComponents';
import HtmlTooltip from './HtmlTooltip';

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

class SelectComponent extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
    this.state = {
      option_true: false,
    };
  }

  // eslint-disable-next-line no-unused-vars
  handleChange = name => option => {
    const { fieldApi, onChange } = this.props;
    if (option) {
      const { value } = option;
      fieldApi.setValue(value);
      if (onChange) {
        onChange(value);
      }
    }
  };

  enableOption = input => {
    const { options } = this.props;
    const length = get(options, 'length', 0);
    // only for huge list
    if (length > 1000) {
      if (typeof input === 'string' && input.length > 1) {
        this.setState({ option_true: true });
      } else {
        this.setState({ option_true: false });
      }
    }
  };

  render() {
    const { fieldApi, fieldState, ...props } = this.props;
    const { value } = fieldState;
    // const { setTouched } = fieldApi;
    const {
      // onChange,
      theme,
      classes,
      // onBlur,
      field,
      initialValue,
      // children,
      multiple,
      /* forwardedRef, //Warning: React does not recognize the `forwardedRef` prop on a DOM element. */

      label = '',
      placeholder = '',
      //   name = "default_name",
      // id = String(Math.floor(Math.random() * 1e8)),
      helperText = '',
      options = [],
      // disabled = false,
      required,
      isDisabled = false,
      isClearable = true,
      isSearchable = true,
      tooltip,
    } = props;
    const cleanValue = value ? options.find(option => option.value === value) : initialValue;

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };

    const getOptions = () => {
      const length = get(options, 'length', 0);
      // only for huge list
      if (length > 1000) {
        return get(this.state, 'option_true', false) ? options : [];
      }
      return options;
    };

    return (
      <>
        {tooltip && (
          <HtmlTooltip title={tooltip}>
            <span className="helper">?</span>
          </HtmlTooltip>
        )}
        <NoSsr>
          <StyledFormControl error={!!fieldState.error}>
            <Select
              required={required}
              classes={classes}
              styles={selectStyles}
              isDisabled={isDisabled}
              isClearable={isClearable}
              isSearchable={isSearchable}
              multiple={multiple}
              ref={this.selectRef}
              name={field}
              cacheOptions
              options={getOptions()}
              defaultValue={cleanValue || (multiple ? [] : '')}
              initialValue={cleanValue}
              // value={cleanValue || (multiple ? [] : '')}
              components={components}
              placeholder={placeholder}
              textFieldProps={{
                label: required ? `${label} *` : label,
                InputLabelProps: {
                  shrink: true,
                },
              }}
              onChange={this.handleChange(field)}
              onInputChange={this.enableOption}
              disabled
              tooltip={tooltip}
            />
            <FormHelperText>{fieldState.error || helperText}</FormHelperText>
          </StyledFormControl>
        </NoSsr>
      </>
    );
  }
}

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: `${theme.spacing(0.5)}px ${theme.spacing(0.25)}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 14,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 14,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
});

SelectComponent.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
  onChange: PropTypes.func.isRequired,
  fieldApi: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  fieldState: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  strings: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  initialValue: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  type: PropTypes.string,
  required: PropTypes.bool,
};

SelectComponent.defaultProps = {
  options: [],
  strings: {
    'lenders.label': 'Lender',
  },
  isDisabled: false,
  isLoading: false,
  isClearable: false,
  isSearchable: true,
  required: true,
  initialValue: undefined,
  type: undefined,
};

export default asField(withStyles(styles, { withTheme: true })(SelectComponent));
